export const AUTOMATED_REVIEW_LOGS_FILTERS_LOCAL_STORAGE_KEY_PREFIX =
  'automated-review-logs-filters-user:';
